import React, { useState, useEffect, useRef } from 'react';
import ControlPanel from './ControlPanel'
import { useNavigate } from 'react-router-dom';
import WordDefinitionBubble from './WordDefinitionBubble';
import dictionary from './dictionaryData';

interface Word {
    word: string;
    start: number;
}

const wordTimings: Word[] = [


    { word: "O Ηρακλής", start: 0.05 },
    { word: "παίρνει", start: 0.06 },
    { word: "μήνυμα", start: 0.07 },
    { word: "από τον θεό Απόλλωνα.", start: 0.08 },
    { word: "Φεύγει", start: 0.11 },
    { word: "για", start: 0.12 },
    { word: "την Πελοπόννησο.", start: 0.13 },
    { word: "Πηγαίνει", start: 0.14 },
    { word: "στις Μυκήνες.", start: 0.15 },
    { word: "Εκεί", start: 0.17 },
    { word: "ο Βασιλιάς Ευρυσθέας", start: 0.18 },
    { word: "δίνει", start: 0.22 },
    { word: "έναν άθλο", start: 0.23 },
    { word: "στον Ηρακλή:", start: 0.24 },
    { word: "Πρέπει", start: 0.26 },
    { word: "να σκοτώσει", start: 0.27 },
    { word: "το λιοντάρι", start: 0.29 },
    { word: "της Νεμέας.", start: 0.30 },
    { word: "Η Νεμέα", start: 0.33 },
    { word: "είναι", start: 0.34 },
    { word: "κοντά", start: 0.35 },
    { word: "στις Μυκήνες.", start: 0.36 },
    { word: "Ο τόπος", start: 0.37 },
    { word: "είναι ένα", start: 0.38 },
    { word: "όνειρο!", start: 0.39 },
    { word: "Έχει", start: 0.41 },
    { word: "όμορφα βουνά", start: 0.42 },
    { word: "με δέντρα", start: 0.43 },
    { word: "και", start: 0.44 },
    { word: "πολλά", start: 0.45 },
    { word: "άγρια ζώα.", start: 0.46 },
    { word: "Το άγριο λιοντάρι", start: 0.48 },
    { word: "όμως", start: 0.49 },
    { word: "τρομοκρατεί", start: 0.50 },
    { word: "την πόλη.", start: 0.51 },
    { word: "Τρώει", start: 0.53 },
    { word: "ζώα και ανθρώπους.", start: 0.54 },
    { word: "Ο Ηρακλής", start: 0.58 },
    { word: "πάει", start: 0.59 },
    { word: "στο βουνό.", start: 1.00 },
    { word: "Βλέπει", start: 1.01 },
    { word: "τα δέντρα", start: 1.02 },
    { word: "και", start: 1.03 },
    { word: "τον ουρανό.", start: 1.03 },
    { word: "Βλέπει", start: 1.04 },
    { word: "πηγές", start: 1.05 },
    { word: "και", start: 1.05 },
    { word: "σπηλιές.", start: 1.06 },
    { word: "Βλέπει", start: 1.07 },
    { word: "λύκους,", start: 1.08 },
    { word: "αλεπούδες", start: 1.09 },
    { word: "και τσακάλια.", start: 1.10 },
    { word: "Ψάχνει", start: 1.12 },
    { word: "το λιοντάρι.", start: 1.13 },
    { word: "Πολλές", start: 1.15 },
    { word: "μέρες", start: 1.16 },
    { word: "και νύχτες", start: 1.17 },
    { word: "περπατάει", start: 1.19 },
    { word: "και κοιτάζει.", start: 1.20 },
    { word: "Κρατάει", start: 1.23 },
    { word: "ένα ρόπαλο.", start: 1.24 },
    { word: "Ψάχνει", start: 1.26 },
    { word: "παντού", start: 1.27 },
    { word: "και", start: 1.28 },
    { word: "περιμένει.", start: 1.29 },
    { word: "Ξαφνικά,", start: 1.31 },
    { word: "το λιοντάρι", start: 1.32 },
    { word: "πλησιάζει", start: 1.34 },
    { word: "τον Ηρακλή.", start: 1.35 },
    { word: "Είναι", start: 1.38 },
    { word: "τεράστιο!", start: 1.39 },
    { word: "Ήρθε η ώρα!", start: 1.40 },
    { word: "Ο Ηρακλής", start: 1.44 },
    { word: "το σημαδεύει.", start: 1.45 },
    { word: "Παίρνει", start: 1.47 },
    { word: "το ρόπαλο", start: 1.48 },
    { word: "και το χτυπάει.", start: 1.49 },
    { word: "Το λιοντάρι", start: 1.52 },//
    { word: "μπαίνει", start: 1.54 },
    { word: "στη σπηλιά του.", start: 1.55 },
    { word: "Ο Ηρακλής", start: 1.56 },
    { word: "παλεύει με", start: 1.58 },
    { word: "το λιοντάρι.", start: 1.59 },
    { word: "Με τα χέρια του", start: 2.00 },
    { word: "γρήγορα", start: 2.03 },//
    { word: "το σκοτώνει.", start: 2.04 },
    { word: "Παίρνει", start: 2.07 },
    { word: "το δέρμα", start: 2.08 },
    { word: "του λιονταριού", start: 2.09 },
    { word: "και", start: 2.10 },
    { word: "το φοράει.", start: 2.11 },
    { word: "Πηγαίνει", start: 2.13 },
    { word: "στον Βασιλιά Ευρυσθέα.", start: 2.15 },
    { word: "Ο Ευρυσθέας", start: 2.17 },
    { word: "βλέπει", start: 2.19 },
    { word: "τον Ηρακλή", start: 2.20 },
    { word: "με", start: 2.21 },
    { word: "τη λεοντή!", start: 2.22 },
    { word: "Τρομάζει", start: 2.23 },
    { word: "και μπαίνει", start: 2.24 },
    { word: "σε ένα", start: 2.26 },
    { word: "πιθάρι!", start: 2.27 }
];

const englishText: string[] = [
    "Hercules had received a message from Apollo saying that he must fulfill 12 labors from his cousin, King Eurystheus. Immediately, Hercules set out on a journey to the Peloponnese. The king was in Mycenae.",
    "Nemea, a town in Mycenae, was known for its beautiful countryside decorated with mountains, trees and enormous plants. Many wild animals lived on these mountains. One lion in particular had upset the whole town of Nemea. It was wreaking havoc over all the countryside disturbing the village and frightening the people.",
    "\"Come here, cousin.\" Said the King. I have a task for you. The King told Hercules of the lion and how it had taken people of the town and shredded them to pieces.\" Hercules, you must kill that lion and save the people of Nemea.\"",
    "Hercules began his search for the lion. He walked for many days listening and waiting for the monster to appear. Then one day, the lion approached Hercules. The lion's size made him look more like a monster than an animal. Hercules immediately shot at him with his bow and arrows but they broke as soon as he touched the lion's legs. His sword was also useless to use to battle the beast. Hercules' last hope was his club that he had carved out of an olive tree. The club injured the lion. The lion made his way into its cave.",
    "Hercules soon made his way into the cave and attacked the lion with his bare hands. The struggle was fierce. Hercules managed to get his hands around the lion's neck and strangle it to death. King Eurystheus saw Hercules wearing the lion mane. He got so scared that he jumpd into a large urn to hide."
]

const GreekTextDisplay: React.FC = () => {
    const [currentWordIndex, setCurrentWordIndex] = useState<number>(-1);
    const [isPlaying, setIsPlaying] = useState<boolean>(false);
    const [audioFinished, setAudioFinished] = useState(false);
    const [language, setLanguage] = useState<'english' | 'greek'>('greek');
    const audioRef = useRef<HTMLAudioElement | null>(null);

    const [selectedWord, setSelectedWord] = useState<string | null>(null);
    const [bubblePosition, setBubblePosition] = useState({ top: 0, left: 0 });
    const bubbleRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const [isFirstAppearance, setIsFirstAppearance] = useState(true);
    const navigate = useNavigate();


    // const dictionary: {
    //     [key: string]: {
    //         definition: string,
    //         partOfSpeech: string,
    //         explanation: string,
    //         audio: string
    //     }
    // } = {
    //     "O Ηρακλής": {
    //         definition: "Hercules",
    //         partOfSpeech: "Noun",
    //         explanation: "Hercules is a man. In Greek, all names have articles. Masculine nouns: article is masculine and the nouns end with -ος, -ης, or -ας.",
    //         audio: "/audio/word1.m4a"
    //     },
    //     "μήνυμα": {
    //         definition: "Message",
    //         partOfSpeech: "Noun",
    //         explanation: "Message is a noun that uses the neuter article (το). Often, neuter nouns and plurals end in -α (-a) or -η (-ē).",
    //         audio: "path/to/message_audio.mp3"
    //     },
    //     "θεό Απόλλωνα": {
    //         definition: "God Apollo",
    //         partOfSpeech: "Noun",
    //         explanation: "Nouns change their endings based on the grammatical structure of the sentence used. The meaning of the noun does not change.",
    //         audio: "path/to/god_apollo_audio.mp3"
    //     },
    //     "Φεύγει": {
    //         definition: "To go or to leave",
    //         partOfSpeech: "Verb",
    //         explanation: "Φεύγω -verbs ending in -ω are usually considered regular verbs. Verbs can be identified with their endings. The third person conjugation of this verb ends with -ει.",
    //         audio: "path/to/to_leave_audio.mp3"
    //     }
    // };




    const handleWordClick = (event: React.MouseEvent, word: string, index: number): void => {
        if (language === 'greek') {
            // console.log(`Clicked on word: ${word}`);
            if (selectedWord == word) {
                setSelectedWord(null);
            }
            else {
                setSelectedWord(word);
            }
            // setSelectedWord(word);
            if (isFirstAppearance) {
                // For the first appearance, set an initial position off-screen
                setBubblePosition({ top: -1000, left: -1000 });
                setIsFirstAppearance(false);
            }

            setTimeout(() => updateBubblePosition(event.target as HTMLElement, word), 200);


        }
    };

    const updateBubblePosition = (target: HTMLElement, word: string) => {
        if (bubbleRef.current && containerRef.current) {
            const wordRect = target.getBoundingClientRect();
            const containerRect = containerRef.current.getBoundingClientRect();
            const bubbleRect = bubbleRef.current.getBoundingClientRect();

            // Calculate initial position (viewport-relative)
            let top = wordRect.top - bubbleRect.height - 10; // 10px above the word
            let left = wordRect.left + (wordRect.width / 2) - (bubbleRect.width / 2);

            top -= containerRef.current.scrollTop;

            // Adjust horizontal position
            const minLeft = containerRect.left - (bubbleRect.width / 2);
            const maxRight = containerRect.right + (bubbleRect.width / 2);
            const maxTop = containerRect.top - bubbleRect.height + 10;

            if (left < minLeft) {
                left = minLeft;
            } else if (left + bubbleRect.width > maxRight) {
                left = maxRight - bubbleRect.width;
            }

            // Ensure the bubble stays within the viewport horizontally
            if (left < 0) {
                left = 0;
            } else if (left + bubbleRect.width > window.innerWidth) {
                left = window.innerWidth - bubbleRect.width;
            }

            // Adjust vertical position
            if (top < maxTop) {
                // If the bubble would go more than 10 units above the container, position it below the word
                top = wordRect.bottom;
            }

            if (top < 0) {
                top = 0;
            } else if (top + bubbleRect.height > window.innerHeight) {
                top = window.innerHeight - bubbleRect.height;
            }

            setBubblePosition({ top, left });
            setSelectedWord(word);
        }
    };


    useEffect(() => {
        if (language === 'greek') {
            audioRef.current = new Audio('/labor1Recording.m4a');
            audioRef.current.addEventListener('ended', () => {
                setIsPlaying(false);
                setAudioFinished(true); // Set this to true when audio ends
                setCurrentWordIndex(-1);
            });
        }
        return () => {
            if (audioRef.current) {
                audioRef.current.removeEventListener('ended', () => {
                    setIsPlaying(false);
                    setCurrentWordIndex(-1);
                });
                audioRef.current.pause();
            }
        };
    }, [language]);

    useEffect(() => {
        if (!audioRef.current || !isPlaying || language !== 'greek') return;

        let animationFrameId: number;

        const updateHighlight = () => {
            if (!audioRef.current || !isPlaying) return;

            const currentTime = audioRef.current.currentTime;
            // const adjustedTime = currentTime + globalOffset;

            const newIndex = wordTimings.findIndex((word, index) =>
                index === wordTimings.length - 1 || currentTime < convertTimeToSeconds(wordTimings[index + 1].start)
            );

            if (newIndex !== currentWordIndex) {
                setCurrentWordIndex(newIndex);
            }

            animationFrameId = requestAnimationFrame(updateHighlight);
        };


        animationFrameId = requestAnimationFrame(updateHighlight);


        return () => {
            cancelAnimationFrame(animationFrameId);
        };
    }, [isPlaying, currentWordIndex, language]);

    const convertTimeToSeconds = (time: number): number => {
        const minutes = Math.floor(time);
        const seconds = (time - minutes) * 100;
        return minutes * 60 + seconds;
    };

    const togglePlay = () => {
        if (language !== 'greek') return;

        if (isPlaying) {
            audioRef.current?.pause();
        } else {
            audioRef.current?.play();
            if (audioFinished && isPlaying) {
                setCurrentWordIndex(-1);
            }
            setAudioFinished(false); // Reset this when audio starts playing
        }
        setIsPlaying(!isPlaying);
    };

    const toggleLanguage = () => {
        setLanguage(prev => prev === 'english' ? 'greek' : 'english');
        setIsPlaying(false);
        setCurrentWordIndex(-1);
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }
    };

    //methods for 
    const handleCloseBubble = () => {
        setSelectedWord(null);
    };

    const handlePronounce = (audioPath: string) => {
        const audio = new Audio(audioPath);
        audio.play().catch(error => console.error("Error playing audio:", error));
    };

    const renderText = () => {
        if (language === 'greek') {
            return (
                <div>
                    {wordTimings.map((wordTiming, index) => (
                        <span
                            key={index}
                            className={`inline-block p-1.5 text-lg font-medium rounded
                            ${index <= currentWordIndex ? 'bg-yellow-200 text-black' : 'text-black'}
                            ${dictionary[wordTiming.word] ? 'underline' : ''}`}
                            onClick={(e) => language === 'greek' && dictionary[wordTiming.word] ? handleWordClick(e, wordTiming.word, index) : null}
                        >
                            {wordTiming.word}{' '}
                        </span>
                    ))}
                </div>
            );
        } else {
            return (
                <div>
                    {englishText.map((sentence, index) => (
                        <p
                            key={index}
                            className="mt-2 text-md font-medium text-black"
                        >
                            {sentence}
                        </p>
                    ))}
                </div>
            );
        }
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (bubbleRef.current && !bubbleRef.current.contains(event.target as Node)) {
                setSelectedWord(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleResourcesClick = () => {
        navigate('/resources');
    };


    return (
        <div style={{
            backgroundImage: "url('/images/sky.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        }}>
            <div className="p-4 h-screen w-screen flex flex-col overflow-hidden relative"
                style={{
                    backgroundImage: "url('/images/temple.png')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}>

                <div className="ml-3 lg:ml-7 relative w-full h-full mt-[5%]" style={{ paddingTop: '60%' }}> {/* 16:9 aspect ratio */}
                    <div
                        className="absolute top-0 left-0 w-[110%] h-[110%] -translate-x-[10%] -translate-y-[10%] min-w-[1300px] min-h-[800px]"
                        style={{
                            backgroundImage: "url('/images/stoneslab.png')",
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        }}
                    >
                        {/* Text overlay container */}
                        <div
                            ref={containerRef}
                            className="absolute top-[49%] left-[51.5%] transform -translate-x-1/2 -translate-y-1/2"
                            style={{
                                width: '62%', // Adjust this value to control how much of the image width the text covers
                                height: '66%', // Adjust this value to control how much of the image height the text covers
                                overflowY: 'auto', // Allow vertical scrolling if text overflows
                                // padding: '5px', // Add some padding inside the text container
                            }}
                        >
                            {renderText()}
                        </div>
                    </div>
                </div>

                {selectedWord && (<WordDefinitionBubble
                    ref={bubbleRef}
                    word={selectedWord}
                    wordInfo={selectedWord ? (dictionary[selectedWord] || null) : null}
                    position={bubblePosition}
                    onClose={handleCloseBubble}
                    onPronounce={handlePronounce}
                    isPlaying={isPlaying}
                    audioFinished={audioFinished}
                />)}

                {/* Position ControlPanel to the right of the text overlay */}
                <div className="absolute top-[38%] right-[5%] transform -translate-y-[50%]">
                    <ControlPanel
                        onLanguageToggle={toggleLanguage}
                        onPlayToggle={togglePlay}
                        onResourcesClick={handleResourcesClick}
                        language={language}
                        isPlaying={isPlaying}
                    />
                </div>


            </div>
        </div>
    );
};

export default GreekTextDisplay;